import { client, request } from "./_base";

export const inspectionlabelrequirements = client("inspectionlabelrequirements", item => ({
  ...item,
}));
